









































































import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { Getter } from 'vuex-class';

@Component
export default class JuuryzeiDialog extends Vue {
  @Prop() code: string;
  @Prop() value: number;
  @Prop({ default: false })
  appendToBody: string;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  
  showDialog: boolean = false;
  hasData: boolean = false;
  cateSelected: string = "";
  kubunSelected: string = "";
  tableData: any = [];
  columns: any = [];
  types: any = [];
  kubuns: any = {};
  data: any = {};
  codeSelected: string = "";
  valueSelected: string = "";
  reqService: requestService;
  loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMessage: string = "";

  created() {
    this.reqService = new requestService();
  }

  async getJuuryouzeiDetail() {
    if (this.codeSelected) {
      const obj: any = await this.reqService.getJuuryouzeiDetail(
        this.codeSelected
      );
      this.cateSelected = obj.weightTaxCarTypeKbnId;
      this.kubunSelected = obj.weightTaxTaxationKbn;
    } else {
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          if (res && res.jidoushaShubetsu && res.jidoushaShubetsu == 3) {
            this.cateSelected = "kei";
          } else {
            this.cateSelected = "normal"
          }
        });
      this.kubunSelected = "0";
    }
    return Promise.resolve(this.cateSelected);
  }

  getJuuryouzeiData() {
    const strDate = util.getNow("YYYYMMDD");
    this.reqService
      .getJuuryouzeiTable(this.kubunSelected, strDate)
      .then((data: any) => {
        this.data = data;
        /** #6550 2020-12-10 sh [START] */
        this.cateSelected = this.cateSelected && this.cateSelected != '' ? this.cateSelected : "kei";
        /** #6550 2020-12-10 sh [END] */
        this.setTableData(this.data[this.cateSelected]);
      });
  }

  setTableData(data: any) {
    console.log("JuuryouseiDialog.setTableData => ", data);
    if (data && data.items && data.items.length > 0) {
      this.$set(this, "tableData", data.items);
      let columns: any = [];
      for (let i = 3; i > 0; i--) {
        columns.push({
          header: data.header[`year${i}`],
          keyDisp: `year${i}Disp`,
          year: i
        });
      }
      this.$set(this, "columns", columns);
      let types: any = [];
      Object.keys(this.data).forEach(key => {
        types.push({ categoryName: this.data[key].categoryName, key });
      });
      this.$set(this, "types", types);
      this.$set(this, "hasData", true);
    }
    this.loading = false;
  }

  setKubuns(data: any) {
    this.$set(this, "kubuns", data);
  }

  selectJuuryouzei(row: any, year: number) {
    const code = row[`codeYear${year}`];
    const value = row[`year${year}`];
    this.codeSelected = code;
    this.valueSelected = value;
    this.$emit("onJuuryouzei", { code, value });
    this.onClose();
  }

  onChangeCategory(cate: string) {
    this.cateSelected = cate;
    this.setTableData(this.data[this.cateSelected]);
  }

  onChangeKbn(kbn: string) {
    this.kubunSelected = kbn;
    this.getJuuryouzeiData();
  }

  cellClassName(row: any, year: number) {
    if (
      this.codeSelected &&
      row.code == this.codeSelected.substring(0, 1) &&
      year == Number(this.codeSelected.substring(1, 2)) &&
      row[`year${year}`] == this.valueSelected
    ) {
      return "selected";
    }
  }

  onOpen() {
    this.showDialog = true;
    this.codeSelected = this.code;
    if (this.value) {
      this.valueSelected = this.value.toString();
    }
    if (this.cateSelected == "") {
      this.getJuuryouzeiDetail().then(cateSelected => {
        this.getJuuryouzeiData();
      });
    }
  }

  onClose() {
    this.showDialog = false;
  }

  getDataError(error: string) {
    this.loading = false;
    this.errorMessage = error;
  }
}
